class DomUtils {
    static htmlToElement(html) {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstElementChild;
    }
    static delay(t) {
        return new Promise((resolve) => setTimeout(resolve, t));
    }
    static stripHTMLTags(content) {
        const $temporaryContainer = document.createElement('div');
        $temporaryContainer.innerHTML = content;
        return `${$temporaryContainer.textContent || ''} `;
    }
}

export { DomUtils };
//# sourceMappingURL=dom_utils.js.map
